import Vue from 'vue'
import { DirectiveBinding } from 'vue/types/options';
import { standardFunctions } from '@/helpers/standardFunctions';

Vue.directive('convert', {
	bind: function(el: any, binding: DirectiveBinding, vnode: any) {
    el.addEventListener('input', function(){
      let convertedValue;
      const { convertFn, source, parent, goodsId, destination, ftProcessRow } = binding.value;
      if (typeof convertFn == 'function') {
        convertedValue = convertFn(vnode.context[source])
      } else if (typeof convertFn == 'string') {
        if(ftProcessRow) {
          convertedValue = standardFunctions[convertFn](vnode.context[source], ftProcessRow.goodsObject)  
        } else {
          const resolvedGoodsId = typeof(goodsId) === 'string' ? parent._resolveFormulaValue(goodsId): goodsId;
          const goodsObject = parent.getGoodFromId(resolvedGoodsId);
          convertedValue = standardFunctions[convertFn](vnode.context[source], goodsObject)  
        }
      }
      convertedValue = Number(convertedValue.toFixed(3));
      if(ftProcessRow) {
        ftProcessRow[destination] = convertedValue;
        ftProcessRow.quantity$.next(convertedValue);
      } else {
        const { targetVariable, lastPart } = getVariables(vnode, binding);
        vnode.componentInstance.$set(targetVariable, lastPart, convertedValue);
      }
    });
  }
})

function getVariables(vnode : any, binding: any) {
  const variable = binding.value.destination ? binding.value.destination : binding.value;
  const parent = binding.value.parent ? binding.value.parent : vnode.context;
  let targetVariable = parent.variables;
  const dividedExpression = variable.split('.');
  const lastPart = dividedExpression.pop()
  dividedExpression.forEach((part: string) => {
    if (targetVariable[part] == undefined) {
      vnode.componentInstance.$set(targetVariable, part, {});
    }
    targetVariable = targetVariable[part];
  })
  return { targetVariable, lastPart };
}
